import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import CategoryPage, { SearchPage } from "@/pages/CategoryPage";
import RankingsPage from "@/pages/RankingsPage";
import {
  SchoolsPage, CollegesPage, SuppliersPage,
  InstitutionPage, SupplierPage, EventsPage, ContactPage,
} from "@/pages/DirectoryPages";
import { LoginPage, RegisterPage } from "@/pages/AuthPages";
import AdminDashboard from "@/pages/AdminDashboard";
import AccountDashboard from "@/pages/AccountDashboard";
import { JobsListPage, JobDetailPage } from "@/pages/JobsPages";
import SubmitPressReleasePage from "@/pages/SubmitPressReleasePage";
import AddMyProfilePage from "@/pages/AddMyProfilePage";
import AiAdvisorPage from "@/pages/AiAdvisorPage";
import AiAdvisorReportPage from "@/pages/AiAdvisorReportPage";
import AiAdvisorPill from "@/components/AiAdvisorPill";
import { EdtechListPage, EdtechDetailPage } from "@/pages/EdtechPages";
import CollegeProfileSamplePage from "@/pages/CollegeProfileSamplePage";
import CollegeProfileSampleV2 from "@/pages/CollegeProfileSampleV2";
import CollegeProfileSampleV3 from "@/pages/CollegeProfileSampleV3";
import UniversityProfileSampleV4 from "@/pages/UniversityProfileSampleV4";
import HomepageSamplePage from "@/pages/HomepageSamplePage";
import DynamicPage from "@/pages/DynamicPage";

function AppShell() {
  const location = useLocation();
  const isFullBleedSample = location.pathname === "/design-sample/homepage";
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollToTop />
      {!isFullBleedSample && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/article/:slug" element={<ArticlePage />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/rankings" element={<RankingsPage />} />
          <Route path="/schools" element={<SchoolsPage />} />
          <Route path="/colleges" element={<CollegesPage />} />
          <Route path="/suppliers" element={<SuppliersPage />} />
          <Route path="/institution/:slug" element={<InstitutionPage />} />
          <Route path="/supplier/:slug" element={<SupplierPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/jobs" element={<JobsListPage />} />
          <Route path="/job/:slug" element={<JobDetailPage />} />
          <Route path="/contact" element={<DynamicPage fixedSlug="contact" />} />
          <Route path="/contact-form" element={<ContactPage />} />
          <Route path="/about" element={<DynamicPage fixedSlug="about" />} />
          <Route path="/page/:slug" element={<DynamicPage />} />
          <Route path="/submit-press-release" element={<SubmitPressReleasePage />} />
          <Route path="/add-my-profile" element={<AddMyProfilePage />} />
          <Route path="/ai-advisor" element={<AiAdvisorPage />} />
          <Route path="/ai-advisor/report/:sid" element={<AiAdvisorReportPage />} />
          <Route path="/edtech" element={<EdtechListPage />} />
          <Route path="/edtech/:slug" element={<EdtechDetailPage />} />
          <Route path="/design-sample/college-profile" element={<CollegeProfileSamplePage />} />
          <Route path="/design-sample/college-profile-v2" element={<CollegeProfileSampleV2 />} />
          <Route path="/design-sample/college-profile-v3" element={<CollegeProfileSampleV3 />} />
          <Route path="/design-sample/university-profile" element={<UniversityProfileSampleV4 />} />
          <Route path="/design-sample/homepage" element={<HomepageSamplePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/dashboard" element={<AccountDashboard />} />
        </Routes>
      </main>
      {!isFullBleedSample && <Footer />}
      <AiAdvisorPill />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <AppShell />
    </BrowserRouter>
  );
}
